import { compose } from 'redux';
import { connect } from 'react-redux';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import selectors from '../../../rootSelectors';
import { createLCResult, fetchLCContent } from '../../lcActions';
import { blockScreen, hideSpinner, showSpinner } from '../../../common/screen/screenActions';
import LCReadingView from './LCReadingView';
import { goToQuestion } from '../../../common/navigation/navigationActions';
import { LC } from '../../../constants/measure';

const mapStateToProps = (state) => {
    const passageHalfIndex = selectors.getLCPassageHalfIndex(state);
    const passage = selectors.getCurrentLCContent(state, passageHalfIndex);
    return {
        passage,
        isSpinnerVisible: selectors.getIsSpinnerVisible(state),
        isDataFetched: selectors.getIsLCDataFetched(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
        currentResult: selectors.findResultFor(state, { measure: LC.MEASURE, isComplete: false }),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchContent: () => dispatch(fetchLCContent()),
        showSpinner: () => dispatch(showSpinner()),
        hideSpinner: () => dispatch(hideSpinner()),
        onNext: () => {
            dispatch(blockScreen());
        },
        goToQuestions: () => {
            dispatch(goToQuestion(LC.ASSESSMENT, null, 1));
        },
        createLCResult: () => dispatch(createLCResult())
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const LCReadingContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(LCReadingView);

export default LCReadingContainer;
